var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feelgrid-puredata" },
    [
      _vm.available_devices.length
        ? [
            _c(
              "header",
              [
                _c("h2", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.views[_vm.view]))
                ]),
                _vm._v(" "),
                _c("ButtonSwitch", {
                  attrs: { options: _vm.views, classname: "lg" },
                  model: {
                    value: _vm.view,
                    callback: function($$v) {
                      _vm.view = $$v
                    },
                    expression: "view"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(_vm.viewcomponents[_vm.view], {
              tag: "div",
              staticClass: "puredata-view",
              attrs: {
                grid: _vm.grid,
                devices: _vm.devices,
                available_devices: _vm.available_devices,
                id: _vm.id
              }
            })
          ]
        : !_vm.devices
          ? _c("Loading")
          : _c("Panel", { staticClass: "user-info" }, [
              _vm._v(_vm._s(_vm._f("trans")("feelgrid:puredata.no_devices")))
            ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bd72b42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd72b42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/feelgrid/modules/pureData/Module.vue
// module id = null
// module chunks = 